
import SEO from './Component/SEO';
import 'animate.css/animate.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import AOS from 'aos';
import 'aos/dist/aos.css';
import "leaflet/dist/leaflet.css";
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Navbar from './Component/Navbar';
import About from './About/About';
import Product from './product/Product';
import ProductReadMore from './product/ProductReadMore';
import Home from './Component/Home';
import Careers from './career/Careers';
import Blog from './Blogs/Blog';
import Contact from './Contact/Contact';
import Privacy from './Component/Privacy';
import Tokenization from './Blogs/Tokenization';
import MobileService from './service-dropdown/MobileService';
import IfileSolution from './casestudy/IfileSolution';
import PlazaSolution from './casestudy/PlazaSolution';
import Iparking from './casestudy/Iparking';
import Project from './career/Project';
import Form3 from './career/Form3';
import TestingService from './service-dropdown/TestingService';
import EsolutionService from './service-dropdown/EsolutionService';
import BussinessService from './service-dropdown/BussinessService';
import DatascienceService from './service-dropdown/DatascienceService';
import React, { useEffect } from 'react';
import OpenPos from './career/OpenPos';
import Project1 from './career/Project1';
import Project2 from './career/Project2';
import ScrollToTop from './Component/ScrollToTop';
import DataEntryService from './service-dropdown/DataEntryService';
import IfileNew from './casestudy/IfileNew';
import Blog1 from './Blogs/Blog1';
import Blog2 from './Blogs/Blog2';
import Blog3 from './Blogs/Blog3';
import NewProduct from './product/NewProduct';
import Service from './Service-New/Service';
import VideoLoader from './Component/VideoLoader';
import Clientele from './clientele/Clientele';
import NextRoof from './product/NextRoof';
import Modular from './product/Modular';
import Flooring from './product/Flooring';
import Acoustics from './product/Acoustics';
import Formjob from './career/Formjob';
import Gallery from './Gallery/Gallery';
import BranchNavbar from './Component/location';
import CataloguePopup from './Component/cateloguepopup';
import ProductDetail from './product/Subcard';
import Subcarddetails from './product/subcarddetails';
import NewsandEvents from './casestudy/NewsandEvents';
import BlogReadMore from './Blogs/BlogReadMore';
import NewsEventsReadMore from './casestudy/NewsEventsReadMore';
import BlogNew1 from './Blogs/BlogNew1';
import NewsandEvents1 from './casestudy/NewsandEvents1';
import BlogNew2 from './Blogs/BlogNew2';
import BlogReadMore2 from './Blogs/BlogReadMore2';
import BlogReadMore3 from './Blogs/BlogReadMore3';
import NewsEventsReadMore2 from './casestudy/NewsandEventsReadmore2';
import JobForm from './career/JobForm';

AOS.init();

function App() {
  useEffect(() => {
    if (document.querySelector(".custom-cursor")) {
      const cursor = document.querySelector(".custom-cursor__cursor");
      const cursorinner = document.querySelector(".custom-cursor__cursor-two");
      const links = document.querySelectorAll("a");

      const handleMouseMove = (e) => {
        cursor.style.transform = `translate3d(calc(${e.clientX}px - 50%), calc(${e.clientY}px - 50%), 0)`;
        cursorinner.style.left = `${e.clientX}px`;
        cursorinner.style.top = `${e.clientY}px`;
      };

      const handleMouseDown = () => {
        cursor.classList.add("click");
        cursorinner.classList.add("custom-cursor__innerhover");
      };

      const handleMouseUp = () => {
        cursor.classList.remove("click");
        cursorinner.classList.remove("custom-cursor__innerhover");
      };

      const handleLinkMouseOver = () => {
        cursor.classList.add("custom-cursor__hover");
      };

      const handleLinkMouseLeave = () => {
        cursor.classList.remove("custom-cursor__hover");
      };

      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mousedown", handleMouseDown);
      document.addEventListener("mouseup", handleMouseUp);

      links.forEach((link) => {
        link.addEventListener("mouseover", handleLinkMouseOver);
        link.addEventListener("mouseleave", handleLinkMouseLeave);
      });

      return () => {
        document.removeEventListener("mousemove", handleMouseMove);
        document.removeEventListener("mousedown", handleMouseDown);
        document.removeEventListener("mouseup", handleMouseUp);
        links.forEach((link) => {
          link.removeEventListener("mouseover", handleLinkMouseOver);
          link.removeEventListener("mouseleave", handleLinkMouseLeave);
        });
      };
    }
  }, []);

  return (
    <>
      <div className='custom-cursor'>
        <div className='custom-cursor__cursor'></div>
        <div className='custom-cursor__cursor-two'></div>
      </div>

      <Router>
        <div>
          <Navbar />
          <ScrollToTop />
          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route path="/about-us" element={<About />} />
            <Route path="/services" element={<Service />} />
            <Route path="/services/mobile-solutions" element={<MobileService />} />
            <Route path="/services/testing" element={<TestingService />} />
            <Route path="/services/enterprise-solutions" element={<EsolutionService />} />
            <Route path="/services/business-intelligence" element={<BussinessService />} />
            <Route path="/services/data-science" element={<DatascienceService />} />
            <Route path="/services/data-entry" element={<DataEntryService />} />
            <Route path="/products" element={<NewProduct />} />
            <Route path="/product/:id" element={<ProductReadMore />} />
            <Route path="/subcard/:mainId" element={<ProductDetail />} />
            <Route path="/Subcarddetails/:id" element={<Subcarddetails />} />
            <Route path="/location" element={<BranchNavbar />} />
            <Route path="/catelogue" element={<CataloguePopup />} />

            <Route path="/careers" element={<Careers />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blogRead/:slug" element={<BlogReadMore3 />} />
            <Route path='/NewsandEvents1' element={<NewsandEvents1 />} />
            <Route path="/contact-us" element={<Contact />} />
            <Route path="/clientele" element={<Clientele />} />
            <Route path='/gallery' element={<Gallery />} />


            <Route path="/privacy" element={<Privacy />} />
            <Route path="/tokan" element={<Tokenization />} />
            <Route path="/read" element={<ProductReadMore />} />
            <Route path="/product-page" element={<NewProduct />} />
            <Route path="/back" element={<Careers />} />

            <Route path="/facade-solutions-metal-ceiling" element={<ProductDetail mainId="16" />} />
            <Route path="/plaza" element={<PlazaSolution />} />
            <Route path="/parking" element={<Iparking />} />

            <Route path="/formjob" element={<Formjob />} />
            <Route path="/project1/:id" element={<Project1 />} />
            <Route path="/project2/:id" element={<Project2 />} />
            <Route path='/form' element={<JobForm />} />
            <Route path="/ApplyHere" element={<Form3 />} />
            <Route path="/explore-job" element={<OpenPos />} />

            <Route path="/blog1" element={<Blog1 />} />
            <Route path="/blog2" element={<Blog2 />} />
            <Route path="/blog3" element={<Blog3 />} />

            <Route path="/blognew2" element={<BlogNew2 />} />

            {/* 6. NEXT GEN ROOFING */}
            <Route path="/services/next-gen-roofing" element={
              <>
                <SEO
                  title="Next Gen Roofing Solutions in India | NLF"
                  description="Explore Next Gen Roofing solutions by NLF, offering advanced and modern roofing systems for commercial and architectural applications."
                  canonical="/services/next-gen-roofing"
                  keywords="Next Gen Roofing, Roofing Solutions, Next Generation Roofing, Next Gen Roofing Solutions, Advanced Roofing Solutions, Modern Roofing Systems, Architectural Roofing, Commercial Roofing Solutions, Roofing Systems  Metal Roofing Solutions, Premium Roofing Systems,	next gen roofing solutions in India, next generation roofing systems in India, advanced roofing solutions for commercial buildings, modern roofing systems in India, commercial roofing solutions in India, architectural roofing solutions in India, 	premium roofing systems for commercial buildings, durable roofing solutions for modern buildings"
                />
                <h1>Next Gen Roofing</h1>
                <ProductReadMore id="43" />
              </>
            } />

            {/* 5. FURNITURE FOR EVERYONE */}
            <Route path="/services/furniture-for-everyone" element={
              <>
                <SEO
                  title="Office & Commercial Furniture Solutions | NLF"
                  description="Explore modern office and commercial furniture solutions from NLF, including workplace furniture, office seating and ergonomic solutions."
                  canonical="/services/furniture-for-everyone"
                  keywords="Office Furniture, Office Furniture Solutions, Furniture Solutions, Commercial Furniture, Corporate Office Furniture, Workplace Furniture, Office Seating Solutions, Ergonomic Office Furniture, Modern Office Furniture, Institutional Furniture, Custom Office Furniture, Business Furniture Solutions, office furniture solutions in India,	commercial office furniture in India, corporate office furniture solutions, ergonomic office furniture for offices, modern workplace furniture solutions, office furniture supplier in India, office seating solutions for commercial spaces, office seating solutions for commercial spaces"
                />
                <h1>Furniture for Everyone</h1>
                <ProductReadMore id="44" />
              </>
            } />

            {/* 7. ACOUSTICS FOR EVERY SPACE */}
            <Route path="/services/acoustics-for-every-space" element={
              <>
                <SEO
                  title="Acoustic Solutions for Every Space | NLF"
                  description="Explore architectural acoustic solutions, acoustic panels, ceilings and wall systems designed to improve sound quality across modern spaces."
                  canonical="/services/acoustics-for-every-space"
                  keywords="Acoustic Solutions, Architectural Acoustic Solutions, Acoustic Products, Acoustic Ceiling Solutions, Acoustic Wall Panels, Sound Absorption Solutions, Office Acoustic Solutions, Interior Acoustic Solutions, Architectural Acoustics, Noise Reduction Solutions, acoustic solutions in India,	architectural acoustic solutions in India, acoustic solutions for offices,	commercial acoustic solutions, acoustic panels for offices,	acoustic ceiling solutions in India, acoustic wall panel solutions, sound absorption solutions for commercial spaces,	noise reduction solutions for offices,	acoustic solutions for every space"
                />
                <h1>Acoustics for Every Space</h1>
                <ProductReadMore id="53" />
              </>
            } />
            {/* <Route path="/services/next-gen-roofing" element={<ProductReadMore id="43" />} /> */}
            {/* <Route path="/services/acoustics-for-every-space" element={<ProductReadMore id="53" />} /> */}
            <Route path="/services/flooring" element={<Flooring />} />
            {/* <Route path="/services/furniture-for-everyone" element={<ProductReadMore id="44" />} /> */}

            <Route path="/blog/:id" element={<BlogReadMore />} />
            <Route path="/blogRead2/:id" element={<BlogReadMore2 />} />
            <Route path="/blogRead3/:id" element={<BlogReadMore3 />} />
            <Route path='/news-events/:id' element={<NewsEventsReadMore />} />
            <Route path='/news-events1/:id' element={<NewsEventsReadMore2 />} />

            {/* Purane URLs → naye URLs (redirect) */}
            <Route path="/about" element={<Navigate to="/about-us" replace />} />
            <Route path="/career" element={<Navigate to="/careers" replace />} />
            <Route path="/blogs" element={<Navigate to="/blog" replace />} />
            <Route path="/Gallery" element={<Navigate to="/gallery" replace />} />
            <Route path="/services/next-gen-roofing" element={<ProductReadMore id="43" />} />
            <Route path="/modular" element={<Navigate to="/services/furniture-for-everyone" replace />} />
            <Route path="/flooring" element={<Navigate to="/services/flooring" replace />} />
            <Route path="/acoustics" element={<Navigate to="/services/acoustics-for-every-space" replace />} />
            <Route path="/Ifile" element={<Navigate to="/facade-solutions-metal-ceiling" replace />} />

            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </div>
      </Router>
    </>
  );
}

export default App;